import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';


class Statements extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			BEG_FISCAL_YEAR: null,
			MONTH: null,
			PI_ROLE_ID: null,
			USER_NAME: '',
			SERVICE_ID: null,
			SPEEDTYPE: '',
		};

		// initialize statement list
		var initialStatementList = this.copyTable(statementList);
		initialStatementList.query.search = this.constructSearch(search);

		this.state = {
			statementList: initialStatementList,
			search: search,
			searchCount: 0,
			renderKey: 1
		};
	}
	
	componentDidMount() {
		var self = this;
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/CRS/Search',
			data: {
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'CURRENT_CYCLE_VW',
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {
				if (data.Data.length === 1) {
					self.mergeState({ 
						cycleBegDate: self.getDate(data.Data[0].BEG_DATE).toLocaleDateString('en-US', {year:'2-digit', month:'2-digit', day:'2-digit'}),
						cycleEndDate: self.getDate(data.Data[0].END_DATE).toLocaleDateString('en-US', {year:'2-digit', month:'2-digit', day:'2-digit'}),
						renderKey: self.state.renderKey + 1
					});
				} else {
					self.showAlert('Cycle Error', 'Expected 1 current billing cycle but found ' + data.Data.length);
				}
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});		
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newStatementList = this.copyTable(statementList);
		newStatementList.query.search = this.constructSearch(this.state.search);
		newStatementList.hold = false;
		this.mergeState({ 
			statementList: newStatementList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};
		
		if (!this.isEmpty(data.BEG_FISCAL_YEAR)) {
			var dtBegFiscalYear = this.getDate(data.BEG_FISCAL_YEAR);
			var dtEndFiscalYear = new Date(dtBegFiscalYear);
			dtEndFiscalYear.setMonth(dtBegFiscalYear.getMonth() + 12);
			search.Children.push({ Attribute: 'DATE_BILLED', Operator: '>=', StringValue: this.formatDateForCompare(dtBegFiscalYear) });
			search.Children.push({ Attribute: 'DATE_BILLED', Operator: '<', StringValue: this.formatDateForCompare(dtEndFiscalYear) });
		}
		if (data.MONTH && data.MONTH.length > 0) {
			search.Children.push({ Attribute: 'MONTH_BILLED', Operator: 'in', IntList: data.MONTH });
		}
		if (data.PI_ROLE_ID && data.PI_ROLE_ID.length > 0) {
			search.Children.push({ Attribute: 'PI_ROLE_ID', Operator: 'in', LongList: data.PI_ROLE_ID });
		}
		if (!this.isEmpty(data.USER_NAME)) search.Children.push({ Attribute: 'USER_NAME', Operator: '=', StringValue: data.USER_NAME });
		if (data.SERVICE_ID && data.SERVICE_ID.length > 0) {
			// join all lists into one list
			search.Children.push({ Attribute: 'SERVICE_ID', Operator: 'in', LongList: data.SERVICE_ID.join(',').split(',') });
		}
		if (!this.isEmpty(data.SPEEDTYPE)) search.Children.push({ Attribute: 'SPEEDTYPE', Operator: 'like', StringValue: data.SPEEDTYPE });
		if (!this.isEmpty(data.PO_NUM)) search.Children.push({ Attribute: 'PO_NUM', Operator: 'like', StringValue: '%' + data.PO_NUM + '%' }); 
		
		// if nothing was specified, forget it
		if (search.Children.length === 0) return null;
		return search;
	}
	
	formatDateForCompare(date) {
		var d = date.getDate();
		var m = date.getMonth() + 1; //Month from 0 to 11
		var y = date.getFullYear();
		return y.toString() + '-' + (m <= 9 ? ('0' + m) : m) + '-' + (d <= 9 ? ('0' + d) : d);
	}

	render() {

		var exportStatementData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Search Past Statements',
			columns: statementExportColumns,
			entity: 'RECHARGES.STATEMENT_VW',
			search: this.constructSearch(this.state.search),
			order: ['PI_NAME','DATE_BILLED','SPEEDTYPE','TRANS_DATE']
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Search Past Statements</span>
					<div style={{ paddingBottom: '10px' }}>Current billing cycle {this.state.cycleBegDate} - {this.state.cycleEndDate}</div>
					<span style={{ fontStyle: 'italic' }}>Prior FY statements may show incorrect recharge rates. Please reach out to <a href='mailto:chemrecharge@berkeley.edu'>chemrecharge@berkeley.edu</a> with any issues.</span>
					<ChemEdit parent={this} columns={statementSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={4} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportStatementData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
								</OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/CRS/Statement'} method='POST'>
								{exportStatementData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
								</OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
				  <Col>
				    <QueryTable renderKey={this.state.renderKey} parent={this} name='CRS_SearchPastStatements' table={this.state.statementList}
					  onResult={(data) => this.onSearchResult(data)} offsetHeight='450px' />
				  </Col>
				</Row>
			</Container>
		</>);
	}
}

const months = [
	{ value: 1, label: 'January' },
	{ value: 2, label: 'February' },
	{ value: 3, label: 'March' },
	{ value: 4, label: 'April' },
	{ value: 5, label: 'May' },
	{ value: 6, label: 'June' },
	{ value: 7, label: 'July' },
	{ value: 8, label: 'August' },
	{ value: 9, label: 'September' },
	{ value: 10, label: 'October' },
	{ value: 11, label: 'November' },
	{ value: 12, label: 'December' }
];

const statementSearch = [
	{ Header: 'Fiscal Year', accessor: 'BEG_FISCAL_YEAR', type: 'select', row: 0, col: 0, required: true,
		options: { value: 'BEG_FISCAL_YEAR', label: 'FISCAL_YEAR', entity: 'RECHARGES.FISCAL_YEAR_SELECT_VW', order: 'BEG_FISCAL_YEAR desc' }},
	{ Header: 'Month', accessor: 'MONTH', type: 'list', row: 0, col: 1, options: months },
	{ Header: 'Service<br /><i>Demurrage will show in statement after 06/30/16</i>', accessor: 'SERVICE_ID', type: 'list', row: 0, col: 2,
		options: { value: 'SERVICE_ID_LIST', label: 'RCH_NAME', entity: 'RECHARGES.STATEMENT_SERVICE_SELECT_VW', order: 'RCH_NAME' }},
	{ Header: 'PI', accessor: 'PI_ROLE_ID', type: 'list', row: 1, col: 0,
		options: { value: 'ROLE_ID', label: 'PI_NAME', entity: 'RECHARGES.STATEMENT_PI_SELECT_VW', order: 'PI_NAME' }},
	{ Header: 'User Name', accessor: 'USER_NAME', row: 1, col: 1, subscript: '(last, first)' },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', row: 1, col: 2, subscript: 'Use % for wild card' },
	{ Header: 'PO', accessor: 'PO_NUM', row: 2, col: 0 }
];

const statementList = {
	query: { entity: 'RECHARGES.STATEMENT_VW', search: null, order: ['PI_NAME','DATE_BILLED','SPEEDTYPE','TRANS_DATE'] },
	pageSize: 20,
	hold: true,
	columns: [
		{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 125 },
		{ Header: 'PI', accessor: 'PI_NAME', width: 150 },
		{ Header: 'Service', accessor: 'SERVICE_NAME', width: 300 },
		{ Header: 'ID', accessor: 'JOBNO', width: 80 },
		{ Header: 'Description', accessor: 'DESCRIPTION', width: 300 },
		{ Header: 'Date', accessor: 'TRANS_DATE', width: 80 },
		{ Header: 'User', accessor: 'USER_NAME', width: 200 },
		{ Header: 'Outside', accessor: 'OUTSIDE_FLAG', width: 75 },
		{ Header: 'PO', accessor: 'PO_NUM', width: 150 },
		{ Header: '$Labor', accessor: 'LABOR_HOURS', width: 80 },
		{ Header: '$Discount', accessor: 'DISCOUNT', width: 80 },
		{ Header: '$Material', accessor: 'MATERIAL_TOTAL', width: 80 },
		{ Header: '$Total', accessor: 'TOTAL_AMOUNT', width: 80 },
		{ Header: 'Billed', accessor: 'DATE_BILLED', width: 100 },
		{ Header: 'Rch ID', accessor: 'RCH_ID', width: 80 }
	]
};

const statementExportColumns = [
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 25 },
	{ Header: 'PI', accessor: 'PI_NAME', width: 30 },
	{ Header: 'Service', accessor: 'SERVICE_NAME', width: 60 },
	{ Header: 'ID', accessor: 'JOBNO', width: 16 },
	{ Header: 'Description', accessor: 'DESCRIPTION', width: 60 },
	{ Header: 'Date', accessor: 'TRANS_DATE', width: 16, format: 'mm/dd/yy' },
	{ Header: 'User', accessor: 'USER_NAME', width: 40 },
	{ Header: 'Outside', accessor: 'OUTSIDE_FLAG', width: 15 },
	{ Header: 'PO', accessor: 'PO_NUM', width: 30 },
	{ Header: '$Labor', accessor: 'LABOR_HOURS', width: 16, format: '#,##0.00' },
	{ Header: '$Discount', accessor: 'DISCOUNT', width: 16, format: '0.00;-0.00;' },
	{ Header: '$Material', accessor: 'MATERIAL_TOTAL', width: 16, format: '#,##0.00' },
	{ Header: '$Total', accessor: 'TOTAL_AMOUNT', width: 16, format: '#,##0.00' },
	{ Header: 'Billed', accessor: 'DATE_BILLED', width: 20, format: 'yyyy-mm-dd' },
	{ Header: 'Rch ID', accessor: 'RCH_ID', width: 16 }
];

export default withRouter(Statements);